import {Directive, Input, DoCheck, OnInit, Injector} from '@angular/core';
import {AbstractControl, NG_VALIDATORS, ValidationErrors, Validator, NgModel} from '@angular/forms';

@Directive({
    selector: '[appNotSameValueAs]',
    providers: [{provide: NG_VALIDATORS, useExisting: NotSameValueAsDirective, multi: true}]
})
export class NotSameValueAsDirective implements Validator, DoCheck, OnInit {

    @Input('appNotSameValueAs') notSameValueAs: any;
    private prevValue: any;
    private model: NgModel;

    constructor(private injector: Injector) {
    }

    ngOnInit() {
        this.model = this.injector.get(NgModel);
    }

    ngDoCheck() {
        if (this.prevValue !== this.notSameValueAs) {
            this.prevValue = this.notSameValueAs;
            this.model.control.updateValueAndValidity();
        }
    }

    validate(control: AbstractControl): ValidationErrors | null {
        return this.validateValue(control);
    }

    validateValue(control: AbstractControl) {
        return control.value !== this.notSameValueAs ? null : {appNotSameValueAs: true};
    }

}
